"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryFromAccount = void 0;
var lodash_1 = require("lodash");
exports.getCountryFromAccount = function (account) {
    if (!account) {
        return null;
    }
    return ((lodash_1.get(account.location, 'country') ||
        lodash_1.get(account.parent, 'location.country') ||
        lodash_1.get(account.parentCollective, 'location.country')) || null);
};
//# sourceMappingURL=utils.js.map